import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';

const LOCALES_HOST = process.env.LOCALES_HOST;
const API_HOST = process.env.API_HOST;

const userLang = localStorage.getItem('language');

const params = JSON.stringify([{"name": "namespace", "operator": "eq", "value": "{{ns}}"}, {"name": "country_code", "operator": "eq", "value": "{{lng}}"}]);

i18next.use(XHR).init({
	lng: "nl",
	ns: ['app', 'common'],
	defaultNS: 'app',
	fallbackNS: 'common',
	nsSeparator: ":::",
	keySeparator: "::",
	fallbackLng: userLang,
    backend: {
		loadPath: LOCALES_HOST ? LOCALES_HOST  : API_HOST+"/language?filters="+params+"&single=true",
		parse: function(json) {return JSON.parse(json).data; }

	},
	debug: true,
});

export const localize = (key, interpolation) => {
	return i18next.t(key, interpolation);
};